import { createContext, useContext } from 'react'

import { type Carrier, type Shipper } from '../domain/Shipment'

type Properties = {
  carrier?: Carrier
  shipper?: Shipper
}

export type ShipmentAnalyticsContextType = Properties | undefined

export type ShipmentAnalyticsProviderType = {
  children: React.ReactNode
  properties: Properties
}

export const ShipmentAnalyticsContext = createContext<ShipmentAnalyticsContextType>(undefined)
ShipmentAnalyticsContext.displayName = 'ShipmentAnalyticsContext'

export function useShipmentAnalyticsContext() {
  const context = useContext(ShipmentAnalyticsContext)

  if (context === undefined) {
    throw new Error('useShipmentAnalyticsContext must be used within a ShipmentAnalyticsContext')
  }

  return context
}

export function ShipmentAnalyticsProvider({ children, properties }: ShipmentAnalyticsProviderType) {
  return (
    <ShipmentAnalyticsContext.Provider value={properties}>
      {children}
    </ShipmentAnalyticsContext.Provider>
  )
}
